<template>
  <div class="flex flex-col gap-8">
    <p class="text-lg font-bold">F.A.Q.</p>
    <div class="flex flex-col gap-2">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="flex flex-col gap-4 rounded-8 bg-grayscale-10 border border-grayscale-20 py-4 px-6 cursor-pointer"
        @click="openedId = openedId === index ? null : index"
      >
        <div class="flex gap-4 items-center justify-between w-full">
          <p class="font-semibold">
            {{ item.title }}
          </p>
          <i v-if="openedId === index" class="icon-minus text-24" />
          <i v-else class="icon-plus text-24" />
        </div>
        <p v-if="openedId === index" class="text-14 text-grayscale-80">
          {{ item.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  items: {
    type: Array as PropType<{ title: string; description: string }[]>,
    required: true,
  },
});

const openedId = ref();
</script>
